module.exports = __webpack_public_path__ + "static/media/collar-measure.3c5c1e20.jpg";